

const skillsList = [
  {
    class: 'devicon-arduino-plain-wordmark',
    title: '',
    color: '#26c6da' 
  },
  {
    class: 'devicon-bootstrap-plain-wordmark',
    title: '',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    } 
  },
  {
    class: 'devicon-bulma-plain',
    title: 'Bulma',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-c-line-wordmark' ,
    title: 'C',
    color: '#00e676'
  },
  {
    class: 'devicon-cplusplus-line' ,
    title: 'C++',
    color: '#00e676'
  },
  {
    class: 'devicon-css3-plain' ,
    title: 'CSS',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-dart-plain' ,
    title: 'Dart',
    color: '#00e676'
  },
  {
    class: 'devicon-electron-original' ,
    title: 'Electron JS',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-embeddedc-plain-wordmark' ,
    title: 'Embedded',
    color: '#00e676'
  },
  {
    class: 'devicon-electron-original' ,
    title: 'Electron JS',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-express-original' ,
    title: 'Express',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-flutter-plain' ,
    title: 'Flutter',
    color: '#26c6da'
  },
  {
    class: 'devicon-git-plain-wordmark' ,
    title: '',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-github-original-wordmark' ,
    title: '',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-heroku-original-wordmark' ,
    title: '',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-html5-plain-wordmark' ,
    title: '',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-ionic-original' ,
    title: 'Ionic',
    color: '#26c6da'
  },
  {
    class: 'devicon-javascript-plain' ,
    title: 'JavaScript',
    color: '#00e676'
  },
  {
    class: 'devicon-jest-plain' ,
    title: 'Jest',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-materialui-plain' ,
    title: 'Material UI',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-mongodb-plain' ,
    title: 'MongoDB',
    color: '#26c6da'
  },
  {
    class: 'devicon-mysql-plain' ,
    title: 'mySQL',
    color: '#26c6da'
  },
  {
    class: 'devicon-nodejs-plain' ,
    title: 'Node',
    color: '#26c6da'
  },
  {
    class: 'devicon-postgresql-plain-wordmark' ,
    title: '',
    color: '#26c6da'
  },
  {
    class: 'devicon-processing-plain-wordmark' ,
    title: '',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-react-original-wordmark' ,
    title: '',
    color: '#26c6da'
  },
  {
    class: 'devicon-redux-original' ,
    title: 'Redux',
    color: '#26c6da'
  },
  {
    class: 'devicon-sass-original' ,
    title: '',
    color: '#b3b3b3',
    display: {
      xs: 'none',
      lg: 'flex'
    }
  },
  {
    class: 'devicon-sequelize-plain' ,
    title: 'Sequelize',
    color: '#26c6da'
  },
  {
    class: 'devicon-sqlite-plain' ,
    title: 'SQLite',
    color: '#26c6da'
  },
]

export default skillsList;